angular.module("rightPaneModule")
    .directive("dblUsage", ['dblUsageStatus', function(dblUsageStatus) {
        return {
            restrict: "E",
            templateUrl: '/resources/right-pane/components/usage/dbl-usage.directive.html',
            replace: true,
            scope: {
                usageData: '=',
                displayAverages: '='
            },
            link: function(scope, element) {
                var MIN_WIDTH_FOR_2_COLUMNS = 720;

                // detect element width change to switch between one and two columns layout
                // by default it will be one column
                scope.$watch(
                  function () {
                    return element.width();
                  },
                  function (width) {
                      scope.twoColumns = width > MIN_WIDTH_FOR_2_COLUMNS;
                  }
                );

                scope.getStatusStyle = function(status) {
                    return "text-" + dblUsageStatus.getStatusString(status);
                };

                scope.getUsageTimeTitle = function(status) {
                    if (status) {
                        return dblUsageStatus.getUsageTimeHoverMessage(status);
                    }
                    return '';
                };

                scope.getUsageLessonsTitle = function(status) {
                    if (status) {
                        return dblUsageStatus.getUsageLessonsHoverMessage(status);
                    }
                    return '';
                };
            }
        };
    }]);
